import { useState } from "react";
import SectionHeading from "../components/SectionHeading";
import { faqs } from "../data/faqs";
import "./Faq.css";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <section id="faq" className="section section--pink faq">
        <img className="faq__deco faq__deco--puzzle" src="/images/puzzle-icon.png" alt="" />
        <img className="faq__deco faq__deco--tower" src="/images/tower-icon.png" alt="" />

        <div className="container">
          <SectionHeading plain="Frequently Asked" accent="Questions" />

          <div className="faq__list">
            {faqs.map(({ question, answer }, i) => {
              const isOpen = openIndex === i;
              return (
                <div key={question} className="faq__item">
                  <h3>
                    <button
                      type="button"
                      className="faq__question"
                      aria-expanded={isOpen}
                      aria-controls={`faq-answer-${i}`}
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                    >
                      <span>{question}</span>
                      <img src={isOpen ? "/images/minus.png" : "/images/plus.png"} alt="" />
                    </button>
                  </h3>
                  <p id={`faq-answer-${i}`} className="faq__answer" hidden={!isOpen}>
                    {answer}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <img className="faq__wave" src="/images/light-pink.png" alt="" />
    </>
  );
}
